export function getDurationInMinutesFromYouTubeFormat(durationString: string) {
  const durationRegex = /PT(\d+M)?(\d+S)?/;
  const match = durationString.match(durationRegex);

  if (!match) {
    throw new Error("Invalid duration string format.");
  }

  const minutesPart = match[1] ? parseInt(match[1].replace("M", "")) : 0;
  const secondsPart = match[2] ? parseInt(match[2].replace("S", "")) : 0;

  const totalMinutes = minutesPart + secondsPart / 60;
  return totalMinutes;
}

export function isOlderThan(dateString: string, hours: number): boolean {
  // Convert input date string to Date object
  let inputDate = new Date(dateString);

  // Get current date and time
  let currentDate = new Date();

  // Calculate the difference in milliseconds
  let diffMs = currentDate.getTime() - inputDate.getTime();

  // Convert difference in milliseconds to hours
  let diffHours = diffMs / (1000 * 60 * 60);

  // Return true if difference is greater than 3 hours
  return diffHours > hours;
}

export const shortDate = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formatter = new Intl.DateTimeFormat(undefined, options);
  const formattedDate = formatter.format(date);

  return formattedDate;
};

export const formatDateForInput = (date: Date) => {
  if (!date) return "";

  const offsetDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  );
  return offsetDate.toISOString().slice(0, 16);
};

// Utility to format a Date as local datetime-local string
export function toLocalDatetimeString(date?: Date): string | undefined {
  if (!date) return undefined;
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes())
  );
}

export function toValidDate(value?: Date | string | null): Date | null {
  if (!value) return null;
  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function getTimezoneShortLabel(date: Date): string {
  const formatter = new Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
  });
  const timezonePart = formatter
    .formatToParts(date)
    .find((part) => part.type === "timeZoneName");
  return timezonePart?.value ?? "UTC";
}
